import "./service-tile.css";

export interface ServiceTile {
  img: string;
  title: string;
  description: string;
}

export function ServiceTile({ img, title, description }: ServiceTile) {
  return (
    <div className='service-tile'>
      <div className="service-description">{description}</div>
      <img className='service-image' src={img} alt={title} />
      <div className='service-title'>{title}</div>
    </div>
  );
}
